export default {
  name: 'Navigation Page',
  label: {
    singlePage: 'Single Page',
    pageTitle: 'Page Title',
    background: 'Background Image',
    childPageTitle: 'Child Page Title',
    childBackground: 'Child Page Background',
    page: 'Page',
    menuLabel: 'Menu Label',
    textColor: 'Text Color',
    fontSize: 'Text Size',
    lineColor: 'Line Color',
    linePadding: 'Line Padding',
    hasSubMenu: 'Has Sub-Menu',
    useParent: 'Use Parent Config',
    sameWithMenuLabel: 'Use Menu Label',
    menuIndex: '{index} Menu',
    activeSubMenu: 'Active(Show) Sub-Menu',
    subMenuCount: '{count} Sub-Menu',
    isRichText: 'Is Rich Text',
    addMenu: 'Add Menu',
    editMenu: 'Edit Menu',
    pagePadding: 'Child Page Padding',
    topPadding: 'Top Padding',
    bottomBtn: 'Bottom Button',
    horizontalPadding: 'Horizontal Padding',
    leftBottomBtn: 'Left',
    rightBottomBtn: 'Right'
  },
  btn: {
    addMenu: 'Add Menu',
    addSubMenu: 'Add Sub-Menu'
  },
  message: {
    emptyMenuListTip: 'please click add button to add menu'
  }
}
